import { render } from "./CreateExternalClinic.vue?vue&type=template&id=426030db&scoped=true"
import script from "./CreateExternalClinic.vue?vue&type=script&lang=js"
export * from "./CreateExternalClinic.vue?vue&type=script&lang=js"

import "./CreateExternalClinic.vue?vue&type=style&index=0&id=426030db&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-426030db"]])

export default __exports__